export default __webpack_public_path__ + "static/4-f7699a6d6202d48d8d88bfc2393a0927.jpeg";